import { DistrictWithStatsDto, MandalType, MandalWithStatsDto } from './master-data.types';

// Enums for ratings
export enum EfficiencyRating {
  Excellent = 'Excellent',
  Good = 'Good',
  Average = 'Average',
  Poor = 'Poor',
}

export enum RiskLevel {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

// Enhanced Mandal interface with additional statistics
export interface EnhancedMandalStats extends MandalWithStatsDto {
  mandal_type: MandalType; // Align with MandalWithStatsDto   
   in_progress_works: number;
    delayed_works: number;
    budget_utilization_percentage: number;
    avg_estimate_cost: number;
    physical_progress_percentage?: number; // Make optional to match reality
    completed_works?: number; // Make optional to match reality
    
  }

// Enhanced District interface with comprehensive statistics
export interface EnhancedDistrictStats extends DistrictWithStatsDto {
  // Financial metrics
  total_ras_amount: number;
  total_expenditure: number;
  pending_bills_amount: number;
  work_not_recorded_amount: number;
  budget_utilization_percentage: number;
  cost_variance: number;
  avg_cost_per_km: number;

  // Progress metrics
  total_length_sanctioned: number;
  total_length_completed: number;
  physical_progress_percentage: number;

  // Work breakdown
  works_not_started: number;
  works_in_progress: number;
  works_completed: number;
  works_on_hold: number;
  delayed_works: number;
  on_schedule_works: number;

  // Grant type breakdown
  central_grants: number;
  state_grants: number;

  // Category breakdown
  plain_category_works: number;
  scp_category_works: number;
  tsp_category_works: number;

  // Work type breakdown
  bt_road_works: number;
  cc_road_works: number;
  bridge_works: number;
  building_works: number;

  // Administrative
  mandals_count: number;
  last_updated: Date;

  // Performance indicators
  performance_score: number;
  efficiency_rating: EfficiencyRating;
  risk_level: RiskLevel;
}

export interface DistrictFilters {
  searchTerm?: string;
  minWorks?: number;
  maxWorks?: number;
  minCost?: number;
  maxCost?: number;
  minProgress?: number;
  maxProgress?: number;
  performanceRating?: EfficiencyRating;
  riskLevel?: RiskLevel;
  sortBy?: keyof EnhancedDistrictStats;
  sortOrder?: 'ASC' | 'DESC';
}

export interface DistrictSummary {
  total_districts: number;
  total_works: number;
  total_estimate_cost: number;
  total_expenditure: number;
  total_length_sanctioned: number;
  total_length_completed: number;
  avg_financial_progress: number;
  avg_physical_progress: number;
  total_delayed_works: number;
  total_completed_works: number;
  highest_performing_district: string;
  lowest_performing_district: string;
  total_mandals: number;
  avg_works_per_district: number;
  avg_cost_per_district: number;
}

// Component Props Interfaces
export interface FilterPanelProps {
  filters: DistrictFilters;
  onFiltersChange: (filters: DistrictFilters) => void;
  onReset: () => void;
  isExpanded: boolean;
  onToggle: () => void;
  activeFiltersCount: number;
}

export interface DistrictsTableProps {
  districts: EnhancedDistrictStats[];
  loading: boolean;
  onDistrictClick: (district: EnhancedDistrictStats) => void;
  sortBy: keyof EnhancedDistrictStats;
  sortOrder: 'ASC' | 'DESC';
  onSort: (field: keyof EnhancedDistrictStats) => void;
}

export interface MandalsTableProps {
  mandals: EnhancedMandalStats[];
  loading: boolean;
  onBack: () => void;
  selectedDistrict: EnhancedDistrictStats;
}